module.exports = __webpack_public_path__ + "static/media/dashboard_walkthroughs.fa2d4ed2.png";